import React, { useEffect, useState } from 'react';
import { Tattoo } from '../types';

interface GalleryProps {
  tattoos: Tattoo[];
  activeCategory: string | null;
  onTattooSelect: (tattoo: Tattoo) => void | Promise<void>;
  hideText?: boolean;
}

const Gallery: React.FC<GalleryProps> = ({ tattoos, activeCategory, onTattooSelect, hideText = false }) => {
  const [selectedTattoo, setSelectedTattoo] = useState<Tattoo | null>(null);
  const [loadedImages, setLoadedImages] = useState<Set<number>>(new Set());
  const [isMobile, setIsMobile] = useState<boolean>(typeof window !== 'undefined' ? window.innerWidth < 768 : false);

  const handleTattooClick = async (tattoo: Tattoo) => {
    setSelectedTattoo(tattoo);
    await onTattooSelect(tattoo);
  };

  const handleImageLoad = (tattooId: number) => {
    setLoadedImages(prev => new Set(prev).add(tattooId));
  };

  const filteredTattoos = activeCategory
    ? tattoos.filter(tattoo => tattoo.categoryId === activeCategory)
    : tattoos;

  // Track window resize so banner order updates without reload
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', onResize, { passive: true });
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <div className="samples__body">
      {filteredTattoos.map((tattoo, index) => {
        if (index === 5) {
          return (
            <React.Fragment key={tattoo.id}>
              {isMobile ? (
                <>
                  <div 
                    className={`mini-card ${selectedTattoo?.id === tattoo.id ? 'mini-card--selected' : ''} ${loadedImages.has(tattoo.id) ? 'mini-card--loaded' : ''}`}
                    onClick={() => handleTattooClick(tattoo)}
                  >
                    <img 
                      src={`${process.env.PUBLIC_URL}/content/images/tattoos/${tattoo.image}`} 
                      alt={`${tattoo.categoryId} tattoo`} 
                      className="mini-card__img"
                      loading="lazy"
                      width={64}
                      height={64}
                      onLoad={() => handleImageLoad(tattoo.id)}
                    />
                    {!hideText && (
                      <div className="mini-card__text">
                        {selectedTattoo?.id === tattoo.id ? 'Selected' : 'Try this'}
                      </div>
                    )}
                  </div>
                  <a className="grid-banner" href="#premium" aria-label="Unlock Premium Tattoos" onClick={(e) => { e.preventDefault(); window.dispatchEvent(new Event('openPremiumModal')); }}>
                    <div className="grid-banner__inner">
                      <div className="grid-banner__title">
                        <img
                          className="grid-banner__icon"
                          src={`${process.env.PUBLIC_URL}/img/lock.png`}
                          alt=""
                          aria-hidden="true"
                        />
                        <div>
                          <div className="grid-banner__headline">Unlock <em>Premium</em> Tattoos</div>
                          <div className="grid-banner__subtitle">Get 100+ exclusive anime tattoos & HD download access</div>
                        </div>
                      </div>
                    </div>
                  </a>
                </>
              ) : (
                <>
                  <a className="grid-banner" href="#premium" aria-label="Unlock Premium Tattoos" onClick={(e) => { e.preventDefault(); window.dispatchEvent(new Event('openPremiumModal')); }}>
                    <div className="grid-banner__inner">
                      <div className="grid-banner__title">
                        <img
                          className="grid-banner__icon"
                          src={`${process.env.PUBLIC_URL}/img/lock.png`}
                          alt=""
                          aria-hidden="true"
                        />
                        <div>
                          <div className="grid-banner__headline"><em>Unlock Premium</em> Tattoos</div>
                          <div className="grid-banner__subtitle">Get 100+ exclusive anime tattoos & HD download access</div>
                        </div>
                      </div>
                    </div>
                  </a>
                  <div 
                    className={`mini-card ${selectedTattoo?.id === tattoo.id ? 'mini-card--selected' : ''} ${loadedImages.has(tattoo.id) ? 'mini-card--loaded' : ''}`}
                    onClick={() => handleTattooClick(tattoo)}
                  >
                    <img 
                      src={`${process.env.PUBLIC_URL}/content/images/tattoos/${tattoo.image}`} 
                      alt={`${tattoo.categoryId} tattoo`} 
                      className="mini-card__img"
                      loading="lazy"
                      width={64}
                      height={64}
                      onLoad={() => handleImageLoad(tattoo.id)}
                    />
                    {!hideText && (
                      <div className="mini-card__text">
                        {selectedTattoo?.id === tattoo.id ? 'Selected' : 'Try this'}
                      </div>
                    )}
                  </div>
                </>
              )}
            </React.Fragment>
          );
        }
        return (
          <React.Fragment key={tattoo.id}>
            <div 
              className={`mini-card ${selectedTattoo?.id === tattoo.id ? 'mini-card--selected' : ''} ${loadedImages.has(tattoo.id) ? 'mini-card--loaded' : ''}`}
              onClick={() => handleTattooClick(tattoo)}
            >
              <img 
                src={`${process.env.PUBLIC_URL}/content/images/tattoos/${tattoo.image}`} 
                alt={`${tattoo.categoryId} tattoo`} 
                className="mini-card__img"
                loading="lazy"
                width={64}
                height={64}
                onLoad={() => handleImageLoad(tattoo.id)}
              />
              {!hideText && (
                <div className="mini-card__text">
                  {selectedTattoo?.id === tattoo.id ? 'Selected' : 'Try this'}
                </div>
              )}
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Gallery;